import type { TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';

export function AlertBody(props: TypographyProps): React.ReactElement {
  return <Typography component="span" variant="paragraphBodyS" {...props} />;
}
